module.exports = __webpack_public_path__ + "img/t_first_prize.95c16709.png";